var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_733_874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 0.666656H2.66671C1.93337 0.666656 1.33337 1.26666 1.33337 1.99999V11.3333H2.66671V1.99999H10.6667V0.666656ZM12.6667 3.33332H5.33337C4.60004 3.33332 4.00004 3.93332 4.00004 4.66666V14C4.00004 14.7333 4.60004 15.3333 5.33337 15.3333H12.6667C13.4 15.3333 14 14.7333 14 14V4.66666C14 3.93332 13.4 3.33332 12.6667 3.33332ZM12.6667 14H5.33337V4.66666H12.6667V14Z",
    fill: "#9CA0A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_733_874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.808fb4bf149f08fccc69e3c452bff818.svg";
export { ForwardRef as ReactComponent };